<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">系統管理 / 使用者管理</b-col>
      <b-col>
        <div class="text-right">
          <button class="btn btn-ptc1" v-b-toggle.collapse1>查詢</button>
          <router-link :to="{ name: 'user_management_add' }" class="btn btn-normal-ptc1" tag="button" v-if="FunctionPermission > 1">新增</router-link>
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-card title="使用者列表" class="mb-2">
        <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
          <fieldset>
            <legend style="font-size: 1rem">資料查詢:</legend>
            <b-form inline>
              <b-input class="mb-2 mr-sm-2 mb-sm-0" id="inputUserName" placeholder="使用者姓名"  v-model="sUserName"/>
              <div>
                <button type="button" class="btn btn-warning text-white" @click="loadUserPerPage(1)">查詢</button>
                <button type="reset" class="btn btn-warning text-white" @click="reset">重設</button>
              </div>
            </b-form>
          </fieldset>
        </b-collapse>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">使用者姓名</th>
              <th scope="col">建立時間</th>
              <th scope="col">動作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in members" :key="item.id">
                <td class="td-middle">{{item.name}}</td>
                <td class="td-middle">{{item.CreatedAt}}</td>
                <td>
                <router-link v-if="FunctionPermission > 1" :to="{ name: 'user_management_edit', params: { userId: item.id, search: search, sName: sUserName, isEdit: item.account == 'admin'? false: true  } }" class="btn-circle btn-circle-ptc1" tag="button" ><i class="fas fa-pencil-alt" v-if="item.account !='admin'" title="編輯"></i><i class="fa fa-search-plus" v-if="item.account == 'admin'" title="明細"></i></router-link> <!-- 分頁處理 -->
                <button class="btn-circle btn-circle-ptc1" @click="showModal('ResetPwd', item.id, item.name)" v-if="FunctionPermission > 1 && item.account != 'admin'"><i class="fas fa-key" title="重設密碼"></i></button>
                <!-- <button class="btn-circle btn-circle-ptc1" @click="showModal('Delete', item.id, item.name)"><i class="fas fa-times"></i></button> -->
                  <button v-show="item.disabledAt <= DateNow && FunctionPermission > 1 && item.account != 'admin'" class="btn-circle btn-circle-ptc1" @click="showModal('Enabled', item.id, item.name)" ><i class="fas fa-lock-open" title="修改為啟用"></i></button>
                  <button v-show="item.disabledAt > DateNow && FunctionPermission > 1 && item.account != 'admin'" class="btn-circle btn-circle-ptc1" @click="showModal('Disabled', item.id, item.name)" ><i class="fas fa-lock" title="修改為停用"></i></button>
                </td>
            </tr>
          </tbody>
        </table>
        <div class="row" style="padding: 0 1rem">
          <b-pagination size="md" :total-rows="search.totalRows" v-model="search.currentPage" :per-page="search.pageRows" @change="loadUserPerPage"></b-pagination>
          <label style="margin:8px">{{search.startRowNum}}到{{search.endRowNum}}，總共 {{search.totalRows}}筆</label>
        </div>
        <b-modal ref="ModalResetPwd" hide-footer title="重設密碼">
                  <div class="d-block text-center" style="margin-bottom: 12px;">
                    確定要「{{userName}}」的密碼還原成預設值嗎？
                  </div>
                  <div class="d-block text-right">
                    <b-btn variant="primary" @click="ResetPwd()">確定</b-btn>
                    <b-btn variant="secondary" @click="hideModalResetPwd">取消</b-btn>
                  </div>
        </b-modal>
        <!-- <b-modal ref="ModalDelete" hide-footer title="系統訊息">
                  <div class="d-block text-center" style="margin-bottom: 12px;">
                    確定要刪除使用者「{{userName}}」？
                  </div>
                  <div class="d-block text-right">
                    <button class="btn btn-normal-ptc1" @click="Delete()">確定</button>
                    <button class="btn btn-ptc1" @click="hideModalDelete">取消</button>
                  </div>
        </b-modal> -->
        <b-modal ref="ModalDisabled" hide-footer title="停用帳號">
                  <div class="d-block text-center" style="margin-bottom: 12px;">
                    確定要停用使用者「{{userName}}」？
                  </div>
                  <div class="d-block text-right">
                    <b-btn variant="primary" @click="Disabled()">確定</b-btn>
                    <b-btn variant="secondary" @click="hideModalDisabled">取消</b-btn>
                  </div>
        </b-modal>
        <b-modal ref="ModalEnabled" hide-footer title="啟用帳號">
                  <div class="d-block text-center" style="margin-bottom: 12px;">
                    確定要啟用使用者「{{userName}}」？
                  </div>
                  <div class="d-block text-right">
                    <b-btn variant="primary" @click="Enabled()">確定</b-btn>
                    <b-btn variant="secondary" @click="hideModalEnabled">取消</b-btn>
                  </div>
        </b-modal>
      </b-card>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import axios from 'axios'
import { API_URL } from '../../store/root.js'
import miniToastr from 'mini-toastr'
// 功能權限function
import {getFunctionPermission} from '../../js/LoginUserFunction.js'

miniToastr.init()
export default {
  name: 'name',
  data () {
    return {
      members: [],
      search: {
        currentPage: 1, // 目前頁(去第幾頁)
        totalRows: 0, // 總筆數
        pageRows: 20, // 一頁幾筆
        startRowNum: 0,
        endRowNum: 0
      },
      sUserName: '', // 查詢條件
      userId: '', // 重設密碼 取得userid
      userName: '', // 重設密碼 取得userName
      DateNow: '', // 今天日期
      disabledAt: '',
      FunctionPermission: 0 // 功能權限
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F02') // 功能權限 帶入功能代碼
    if (this.FunctionPermission > 0) {
      // let companyId = localStorage.getItem('COMPANY')
      // console.log('companyId:' + companyId)
      // 分頁處理 : for 第一次進查詢頁 & 從編輯頁跳回來時
      this.sUserName = this.$route.params.sName
      var search = this.$route.params.search
      if (search !== undefined) {
        this.search = search
        this.loadUserPerPage(this.search.currentPage)
      } else {
        this.loadUserPerPage(1)
      }
      // for 鎖定/解鎖
      var date = new Date()
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var month = ('0' + mon).substr(-2)
      var day = ('0' + date.getDate()).substr(-2)
      this.DateNow = year.toString() + month.toString() + day.toString()
    } else {
      this.$router.push({ name: 'name' })
    }
  },
  // computed: mapGetters({
  //   // 取得 loading state
  //   // loading: 'getLoading'
  // }),
  methods: {
    reset () {
      this.sUserName = ''
      this.search.currentPage = 1
      this.loadUserPerPage(1)
    },
    loadUserPerPage (currentPage) {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/user/page/v1', {
        ToPage: currentPage,
        PerPage: this.search.pageRows,
        UserName: this.sUserName // 查詢條件
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.members = response.data.data
            this.search.totalRows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
            this.search.currentPage = response.data.pageNumber // 分頁處理 : 從編輯頁回列表時，跳回目前分頁
            this.$parent.Loading = false
            this.search.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.search.pageRows * (this.search.currentPage - 1) + 1
            this.search.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.search.pageRows > response.data.totalRows) ? response.data.totalRows : (this.search.currentPage * this.search.pageRows) >= response.data.totalRows ? response.data.totalRows : this.search.currentPage * this.search.pageRows
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
              this.$parent.Loading = false
            }
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    showModal (mode, id, name) {
      if (mode === 'ResetPwd') {
        this.$refs.ModalResetPwd.show()
      }
      if (mode === 'Disabled') {
        this.$refs.ModalDisabled.show()
      }
      if (mode === 'Enabled') {
        this.$refs.ModalEnabled.show()
      }
      this.userId = id
      this.userName = name
    },
    hideModalResetPwd () {
      this.$refs.ModalResetPwd.hide()
    },
    hideModalDisabled () {
      this.$refs.ModalDisabled.hide()
    },
    hideModalEnabled () {
      this.$refs.ModalEnabled.hide()
    },
    ResetPwd () {
      this.hideModalResetPwd()
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/user/page/reset_pwd', {
        UserId: this.userId
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('重設密碼成功')
            this.$parent.Loading = false
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
              this.$parent.Loading = false
            }
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    /* Delete () {
      this.hideModalDelete()
      return axios.post(API_URL + '/web/user/page/edit_delete', {
        UserId: this.userId
      })
        .then((response) => {
          console.log('2. Promise resolve vue')
          console.log(response.data.result)
          miniToastr.success('刪除使用者成功')
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error, 'Error')
        })
    }, */
    Disabled () {
      this.hideModalDisabled()
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/user/page/edit_disabled', {
        mode: 'disabled',
        UserId: this.userId
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('停用使用者成功')
            this.$parent.Loading = false
            this.loadUserPerPage(this.currentPage)
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
              this.$parent.Loading = false
            }
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    Enabled () {
      this.hideModalEnabled()
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/user/page/edit_disabled', {
        mode: 'enabled',
        UserId: this.userId
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('啟用使用者成功')
            this.$parent.Loading = false
            this.loadUserPerPage(this.currentPage)
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
              this.$parent.Loading = false
            }
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/userManagement.vue